"use client";
/*
 * Documentation:
 * DC_Button_Close — https://app.subframe.com/4f62853ee923/library?component=DC_Button_Close_02ec14f6-6031-4982-9e70-49205023ae5a
 * Icon Button — https://app.subframe.com/4f62853ee923/library?component=Icon+Button_af9405b1-8c54-4e01-9786-5aad308224f6
 */

import React from "react";
import { FeatherX } from "@subframe/core";
import * as SubframeUtils from "../utils";
import { IconButton } from "./IconButton";

interface Dc_Button_CloseRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Dc_Button_CloseRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Button_CloseRootProps
>(function Dc_Button_CloseRoot(
  { className, ...otherProps }: Dc_Button_CloseRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex items-center justify-between",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <IconButton variant="neutral-primary" size="large" icon={<FeatherX />} />
    </div>
  );
});

export const Dc_Button_Close = Dc_Button_CloseRoot;
